'use client'

import { AppWrapper } from '~/components/app-wrapper'
import { SchedulingAnswerPage } from '~/domains/scheduling/answer/page'

export const Page = () => {
	return (
		<AppWrapper className='relative'>
			<SchedulingAnswerPage />
		</AppWrapper>
	)
}
